import moment from "moment";

export function dateFormatter(_date) {
    if (_date) {
        const dateObject = (typeof _date) == 'string' ? new Date(_date) : _date;
        const year = dateObject.getFullYear();
        const month = dateObject.getMonth() + 1;
        const day = dateObject.getDate();
        const formattedDate = `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
        return formattedDate;
    }
}
export function calculateDifference(toDate, fromDate) {
    let a = moment(toDate);
    let b = moment(fromDate);
    let years = a.diff(b, 'year');
    b.add(years, 'years');
    let months = a.diff(b, 'months');
    b.add(months, 'months');
    let days = a.diff(b, 'days');
    let difference = years + ' years ' + months + ' months ' + days + ' days';
    return difference;
}
export function calculateDifferenceInDays(start_date) {
    if (this.candidate_history_info.length > 0) {
        const candidateHistoryLastIndex = this.candidate_history_info.length - 1
        const end_date = this.candidate_history_info[candidateHistoryLastIndex].end_date;
        let startDate = moment(end_date);
        let endDate = moment(start_date);
        let daysDiff = endDate.diff(startDate, 'days');
        if (daysDiff < 28) {
            return true;
        }
        return false;
    }
    return true;
}
export function fullName(candidate) {
    let fullName = `${candidate.forename} ${candidate.middle_name} ${candidate.surname}`;
    return candidate.full_name ?? fullName;
}
export function checkPolicyDeclaration(policyDeclarationInfo) {
    return policyDeclarationInfo.applicant_screening === true &&
        policyDeclarationInfo.criminal_background_check === true &&
        policyDeclarationInfo.declaration_by_applicant === true &&
        policyDeclarationInfo.financial_history === true &&
        policyDeclarationInfo.equality === true &&
        policyDeclarationInfo.working_time_directive === 'yes';
}
export function saveBtnHandler(companyId = null) {
    let employment = this.candidateHistoryInfo.filter(x => x.type === 0);

    let education = this.candidateHistoryInfo.filter(x => x.type === 1);

    let selfEmployment = this.candidateHistoryInfo.filter(x => x.type === 2);

    let unEmployment = this.candidateHistoryInfo.filter(x => x.type === 3);

    this.registrationForm = {
        applicant: this.basicInfo,
        applicantPayroll: this.payrollInfo,
        applicantAddress: this.addressInfo,
        applicantTraining: this.trainingInfo,
        applicantEmployment: employment,
        applicantEducation: education,
        applicantSelfEmployment: selfEmployment,
        applicantUnemployment: unEmployment,
        applicantSiaDetail: this.siaInfo,
        applicantGdprDetail: this.gdprInfo,
        applicantPolicyDeclaration: this.policyDeclarationInfo,
        searchAction: this.searchAction ?? []
    };
    if(companyId){
        this.registrationForm.company_id = companyId
    }

    this.save(this.registrationForm);
}

export function validateAlphaNumericSixteenCharacter(input) {
    const regex = /^[a-zA-Z0-9]{16}$/;
    return regex.test(input);
}
export function validateAlphaNumeric(input, ) {
    // Regular expression to match alphanumeric characters and spaces only
    const regex = /^[a-zA-Z0-9 ]*$/;

    // Test the input against the regex
    const isValid = regex.test(input);

    return isValid;
}
export function validateAlphabet(input) {
    // Regular expression to match alphanumeric characters and spaces only
    const regex = /^[a-zA-Z\s]*$/;

    // Test the input against the regex
    const isValid = regex.test(input);

    return isValid;
}
export function validateNumeric(input, length = null) {
    // Regular expression to match numeric characters and spaces only
    const regex = /^[0-9\s]*$/;

    // Test the input against the regex
    let isValid = regex.test(input);

    // If the length is provided and not null, truncate the input to the specified length
    if (isValid && length !== null && !isNaN(length)) {
        input = input.substring(0, length);
    }

    // Return the truncated input and the validity status
    return { isValid, input };
}

export function validateEmail(input) {
    return String(input)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
}

export function mergeDateTime(dateStr, timeStr) {
    // Step 1: Parse the date string to create a Date object
    let date = new Date(dateStr);

    // Step 2: Parse the time string to extract hours and minutes
    const timeParts = timeStr.match(/(\d+):(\d+)\s*(AM|PM)/i);
    if (!timeParts) {
        throw new Error('Invalid time format');
    }

    let hours = parseInt(timeParts[1], 10);
    const minutes = parseInt(timeParts[2], 10);
    const period = timeParts[3].toUpperCase();

    // Convert 12 AM/PM to 24-hour format
    if (period === 'PM' && hours < 12) {
        hours += 12;
    } else if (period === 'AM' && hours === 12) {
        hours = 0;
    }

    // Step 3: Adjust the hours and minutes of the Date object
    date.setHours(hours);
    date.setMinutes(minutes);
    date.setSeconds(0);
    date.setMilliseconds(0);
    return date;
};
